const rolePermissions = {
  SUPER_ADMIN: [
    "Dashboard",
    "ViewProduct",
    "AddSingleProduct",
    "ViewCategory",
    "OrderHistory",
    "HomePageMangement",
    "BannerList",
    "CollectionManagement",
    "CollectionProducts",
    "SponserdProduct",
    "OrderDetail",
    "AddToCollection",
    "AddToSponsored",
    "TopProduct",
    "UserTickets",
    "MarketingAnalytics",
    "AdminUser",
    "Users",
    "Profile",
  ],

  ADMIN: [
    "Dashboard",
    "Profile",
  ],

  MARKETING: [
    "Dashboard",
    "MarketingAnalytics",
    "Profile",
  ],

  STANDARD: [
    "Dashboard",
    "Profile",
  ],
};

export default rolePermissions;